const PromoCodes = require("../components/PromoCodes");
const { connect } = require("react-redux");
const {
    deletePromoCode,
    fetchSinglePromoCode,
    updatePromoCode
} = require("actions/promocodes");

module.exports = connect(
    state => ({
        isFetching: state.promocodes.isFetching,
        isSaving: state.promocodes.isSaving,
        promoCodes: state.promocodes.items
    }),
    { deletePromoCode, fetchSinglePromoCode, updatePromoCode }
)(PromoCodes);



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes-edit/containers/PromoCodes.js